import React from 'react';

function Footer(props){

    let styles = {};
    let footerLinks = [];
    let footerLinkComponent = null;
    let footerText = null;
    let footerMarkup = null;
    
    if(typeof props.styles.footerStyle === "undefined"){
        styles.backgroundColor = '#343a40';
        styles.color = '#FFF';
        styles.linkColor = '#FFF';
    }else{
        styles.backgroundColor = props.styles.footerStyle.backgroundColor;
        styles.color = props.styles.footerStyle.color; 
        styles.linkColor = props.styles.footerStyle.color;       
    }

    if(!typeof props.footer.footerLinks === "undefined"){
        footerLinks = props.footer.footerLinks;
    }

    let footerStyle = {
        backgroundColor : styles.backgroundColor || '#343a40',
        color : styles.color || '#FFF',
        paddingTop: "0.8rem",
        paddingBottom: '0.8rem',
        fontSize : '0.9rem'

    };

    //code added by anand
    if(props.template === "SOCIALIZE" || props.template === "SOCIALIZE_FOOTER"){
        footerStyle = {
            backgroundColor: '#F2DEDE',
            color: '#000',
            paddingTop: "0.8rem",
            paddingBottom: '0.8rem',
            fontSize: '0.9rem'
        };
    }
    //--end.

    const linkStyle = {
        color : styles.linkColor || '#FFF'
    };

    if(props.footer.footerText){
        footerText = <li className="list-inline-item">{null}</li>;
    }else{
        footerText= null;
    }

    if(footerLinks.length){
        footerLinkComponent = footerLinks.map((link) => <li key={link.link} className="list-inline-item"><a style={linkStyle} href={link.link} target={link.newwindow === true ? '_blank':'' }>{link.label}</a></li>);    
    }else{
        footerLinkComponent = null;
    }

    if(footerLinks.length || props.footer.footerText){
        footerMarkup =  <section className="footer" style={footerStyle}>
            <nav className="container">{footerText}{footerLinkComponent}</nav>
        </section>;
    }
    return footerMarkup;
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js